var _circle, _path, _path2, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosedMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7684,
    cy: 31.7684,
    r: 29.953,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1362 28.8469C44.3913 29.2719 44.4762 29.6969 44.4762 30.2069V41.6813C44.4762 42.2763 44.3062 42.7864 44.0512 43.2963L37.9314 37.0916C37.2514 36.4116 36.1465 37.4316 36.8264 38.1116L43.031 44.4016C42.5211 44.7415 41.926 44.9115 41.2461 44.9115H22.2916C21.6116 44.9115 21.0166 44.7415 20.5067 44.4016L26.7113 38.1116C27.3914 37.4315 26.2863 36.4115 25.6063 37.0916L19.4865 43.2963C19.2315 42.7864 19.0615 42.2763 19.0615 41.6813V30.2069C19.0615 29.6969 19.1466 29.2719 19.4015 28.8469L29.0063 36.7519C30.5361 38.0269 33.0011 38.1118 34.5313 36.837L44.1361 28.8471L44.1362 28.8469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5116 35.6468C32.5766 36.4117 30.9617 36.4117 29.9417 35.6468L20.3369 27.6569L29.9417 19.6671C30.9617 18.9021 32.5766 18.817 33.5116 19.6671L43.2013 27.6569L33.5116 35.6468Z",
    fill: "#FFBC00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.723,
    cy: 44.4757,
    r: 2.723,
    fill: "#3C37FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0138,
    cy: 6.35366,
    r: 6.35366,
    fill: "#3C37FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedMail);
export default __webpack_public_path__ + "static/media/closedMail.5234c957fdab82371ec8bbc246381b1e.svg";
export { ForwardRef as ReactComponent };